import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SectionTitle from "../common/SectionTitle";
import QuarriesCard from "./QuarriesCard";

function QuarriesAntalyaElmali2() {
  const { t } = useTranslation();

  return (
    <section className="p-5 text-center ocaklarimiz" id="antalyaelmali2">
      <div className="container" style={{ marginTop: "5rem" }}>
        <SectionTitle title={t("ANTALYA ELMALI - 2")} />
      </div>

      <div className="row row-cols-1 row-cols-md-3 g-4">
        <div className="col mb-4">
          <QuarriesCard
            link="/letoonbeige"
            title={t("Letoon Beige")}
            picture="/assets/img/Elmalı Letoon-2.webp"
            company="Elmalı Madencilik İnş. Ltd. Şti."
          />
        </div>

        <div className="col mb-4">
          <QuarriesCard
            link="/shandianbeige"
            title={t("Shandian Beige")}
            picture="/assets/img/Elmalı Shandian Slaps-2.webp"
            company="Elmalı Madencilik İnş. Ltd. Şti."
          />
        </div>

        <div className="col mb-4">
          <QuarriesCard
            link="/cremamontanabeige"
            title={t("Crema Montana Beige")}
            picture="/assets/img/Crema-Montana.webp"
            company="Elmalı Madencilik İnş. Ltd. Şti."
          />
        </div>

      </div>
    </section>
  );
}

export default QuarriesAntalyaElmali2;